import React from 'react';
import RivetApp from './rivet/RivetApp';

export default function App() {
  return <RivetApp />;
}
